


class AlertConfirmClass{
    constructor(){
        this.main = document.getElementById('alert_confirm');

        this._icon = this.main.querySelector('.icon');
        this._title = this.main.querySelector('.title');
        this._description = this.main.querySelector('.description');
        this._list = this.main.querySelector('.list-items');
        
        this._cancelBtn = this.main.querySelector('.cancel_btn');
        this._acceptBtn = this.main.querySelector('.accept_btn');
        
        this._resolveFunction = null;

        this._cancelBtn.addEventListener('click', this._onClickCancelBtn.bind(this));
        this._acceptBtn.addEventListener('click', this._onClickAcceptBtn.bind(this));
    }
    
    /**
     * Show modal with configurable options.
     * 
     * @param {Object} options - Configuration options for the modal.
     * @param {string|null} options.background - The background color of the modal. Default is null
     * @param {string|null} options.icon - The icon to display (e.g., 'warning', 'success', 'info'). Default is null.
     * @param {string} options.title - The title of the modal. Default is 'Your Title'.
     * @param {string|null} options.description - The description of the modal. Default is null.
     * @param {Object|null} options.cancelBtn - Configuration for the cancel button.
     * @param {string} [options.cancelBtn.text='Cancel'] - Text for the cancel button.
     * @param {string} [options.cancelBtn.type='link'] - Type of the cancel button ('link' or 'button').
     * @param {string} [options.cancelBtn.color='black'] - Color of the cancel button.
     * @param {string} [options.cancelBtn.size='3'] - Size of the cancel button (1 to 5).
     * @param {Object|null} options.acceptBtn - Configuration for the accept button.
     * @param {string} [options.acceptBtn.text='Ok'] - Text for the accept button.
     * @param {string} [options.acceptBtn.type='link'] - Type of the accept button ('link' or 'button').
     * @param {string} [options.acceptBtn.color='primary'] - Color of the accept button.
     * @param {string} [options.acceptBtn.size='3'] - Size of the accept button (1 to 5).
     * @param {number} [options.modalSize=5] - Size of the modal (1 to 7). Default is 5.
     * @param {Array} [options.listItems=[]] - List items to populate in the modal. Default is an empty array.
     */
    show(options = {}) {
        const {
            background = null,
            icon = null,
            title = 'Your Title',
            description = null,
            cancelBtn = null,
            acceptBtn = null,
            modalSize = 5,
            listItems = []
        } = options;

        const defaultCancelBtn = {
            text: 'Cancel',
            type: 'link', // 'link' or 'button'
            color: 'black',
            size: '2' // 1 to 5
        };

        const defaultAcceptBtn = {
            text: 'Ok',
            type: 'link', // 'link' or 'button'
            color: 'primary',
            size: '2' // 1 to 5
        };

        // Ensure cancelBtn and acceptBtn are always objects before merging
        const finalCancelBtn = cancelBtn ? Object.assign({}, defaultCancelBtn, cancelBtn) : null;
        const finalAcceptBtn = acceptBtn ? Object.assign({}, defaultAcceptBtn, acceptBtn) : null;

        // Simplified modal size class assignment
        this.main.classList.add(`modal--size-${modalSize}`);

        const bgClasses = Array.from(this.main.classList).filter(className => className.startsWith('modal--bg-'));
        bgClasses.forEach(className => this.main.classList.remove(className));

        if (background) {
            this.main.classList.add(`modal--bg-${background}`);
        }

        this._title.innerHTML = title;

        if (description == null) {
            this._description.style.display = 'none';
        } else {
            this._description.style.display = 'block';
            this._description.innerHTML = description;
        }

        if (listItems.length > 0) {
            this._populateList(listItems);
        }

        if (icon == null) {
            this._icon.classList.add('d-none');
        } else {
            switch (icon) {
                case 'warning':
                    this._icon.src = `${IMG_PATH}icons/alert/warning.svg`;
                    this._icon.width = 60;
                    break;
                case 'warning-orange':
                    this._icon.src = `${IMG_PATH}icons/alert/warning-orange.svg`;
                    this._icon.width = 60;
                    break;
                case 'success':
                    this._icon.src = `${IMG_PATH}icons/alert/success.svg`;
                    this._icon.width = 60;
                    break;
                case 'list-tick':
                    this._icon.src = `${IMG_PATH}icons/alert/list-tick.svg`;
                    this._icon.width = 60;
                    break;
                case 'warning-duplicate':
                    this._icon.src = `${IMG_PATH}icons/alert/warning-duplicate.svg`;
                    this._icon.width = 100;
                    break;
                case 'price-changed':
                    this._icon.src = `${IMG_PATH}icons/alert/price-changed.svg`;
                    this._icon.width = 80;
                    break;
                case 'campaign':
                    this._icon.src = `${IMG_PATH}icons/alert/campaigns.svg`;
                    this._icon.width = 60;
                    break;
                case 'info':
                default:
                    this._icon.src = `${IMG_PATH}icons/alert/info.svg`;
                    this._icon.width = 60;
                    break;
            }
        }

        if (finalCancelBtn == null) {
            this._cancelBtn.closest('.col--btn').style.display = 'none';
        } else {
            this._cancelBtn.closest('.col--btn').style.display = 'inline-flex';
            this._cancelBtn.innerHTML = finalCancelBtn.text;
            if (finalCancelBtn.type === 'link') {
                this._cancelBtn.classList.add('link');
                this._cancelBtn.classList.add(`link--color-${finalCancelBtn.color}`);
                this._cancelBtn.classList.add(`link--size-${finalCancelBtn.size}`);
            } else if (finalCancelBtn.type === 'button') {
                this._cancelBtn.classList.add('button');
                this._cancelBtn.classList.add(`button--${finalCancelBtn.color}`);
                this._cancelBtn.classList.add(`button--size-${finalCancelBtn.size}`);
            }
        }

        if (finalAcceptBtn == null) {
            this._acceptBtn.style.display = 'none';
        } else {
            this._acceptBtn.style.display = 'inline-flex';
            this._acceptBtn.innerHTML = finalAcceptBtn.text;
            if (finalAcceptBtn.type === 'link') {
                this._acceptBtn.classList.add('link');
                this._acceptBtn.classList.add(`link--color-${finalAcceptBtn.color}`);
                this._acceptBtn.classList.add(`link--size-${finalAcceptBtn.size}`);
            } else if (finalAcceptBtn.type === 'button') {
                this._acceptBtn.classList.add('button');
                this._acceptBtn.classList.add(`button--${finalAcceptBtn.color}`);
                this._acceptBtn.classList.add(`button--size-${finalAcceptBtn.size}`);
            }
        }

        document.body.classList.add('block-scroll');
        this.main.classList.add('modal--show');

        setTimeout(() => {
            this.main.classList.add('modal--anim');
        }, 100);

        return new Promise((resolve, reject) => {
            this._resolveFunction = resolve;
        });
    }


    

    _populateList(list){
        if (list) {
            const items = list.map(element => `<span class="border-radius background-gray-50 p-2 m-2 paragraph paragraph--size-6">${element}</span>`).join('');
            this._list.querySelector('div').innerHTML = items;
            this._list.classList.remove('d-none');
          }
    }

    _hide(){
        this.main.classList.remove('modal--anim');

        setTimeout(()=>{
            this.main.classList.remove('modal--show');
            document.body.classList.remove('block-scroll');
        }, 750);
    }

  
    _onClickCancelBtn(e){
        e.preventDefault();
        e.stopPropagation();

        this._hide();
        
        this._resolveFunction(false);
        
    }

    _onClickAcceptBtn(e){
        e.preventDefault();
        e.stopPropagation();
        
        this._hide();
        
        this._resolveFunction(true);
    }
}

const AlertConfirm = new AlertConfirmClass();

Object.seal(AlertConfirm);

export default AlertConfirm;